import React, {ReactNode} from "react";
import AbstractAnnotation, {AbstractAnnotationProperties} from "../AbstractAnnotation";
import AnnotationRectangle from "../AnnotationRectangle";
import {Annotation, Markup, MetadataRectangle} from "@softvision/webpdf-wsclient-9-typescript/lib/generated-sources";
import {ReceivedStamp} from "../../../../../shared/annotation/stamp/ReceivedStamp";
import FunctionHelper from "../../../../../shared/helper/FunctionHelper";

export class ReceivedStampAnnotation extends AbstractAnnotation<AbstractAnnotationProperties> {
	/**
	 * render component as react node
	 */
	public render(): ReactNode {
		let annotation: Annotation = Annotation.fromJson(this.props.annotation.get());
		let rectBoundaries: MetadataRectangle = this.getRectangleBoundaries();
		let opacity: number = FunctionHelper.applyValue(annotation.markup?.opacity, Markup.getOpacityDefault()) / 100;
		let rotation: number = 360 - FunctionHelper.applyValue(annotation.rotation, Annotation.getRotationDefault());

		return (
			<AnnotationRectangle {...this.props} {...rectBoundaries}
								 className={"annotation annotation-" + annotation.subType!.toLowerCase()}
								 style={{
									 zIndex: 0
								 }}>
				<ReceivedStamp width={"auto"} height={"auto"} language={this.props.language} opacity={opacity}
							   rotation={rotation} date={annotation.markup?.creationDate}/>
			</AnnotationRectangle>
		);
	}
}